<script>
import { mapState } from 'pinia';
import { orderStore } from '../../../stores/order';

export default {
	computed: {
		...mapState(orderStore, ['currentPaymentSystem']),
	}
};
</script>

<template>
	<div v-show="false">
		<input
			type="hidden"
			name="PAY_SYSTEM_ID"
			:value="currentPaymentSystem.id"
		>
	</div>
	
</template>

<style scoped>

</style>
